'use client';

import { Box, Stack, useMediaQuery } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { LAYOUT_VARIANT } from '@/configs/layout';
import { SEARCH_TYPE } from '@/constants/searchType';
import PublicSearchInput from '@/components/publicSearch/searchSection/PublicSearchInput';
import SearchDisplayTypeSelection from '@/components/publicSearch/searchSection/SearchDisplayTypeSelection';
import { useSyncQuickSearchDefaultOperator } from '@/components/publicSearch/search/hooks/useQuickSearchDefaultOperator';
import { usePublicSearchUrlSync } from '@/hooks/publicSearch/usePublicSearchUrlSync';
import { useSearchType } from '@/hooks/publicSearch/useSearchType';
import { black } from '@/lib/colours';
import { theme } from '@/lib/theme';
import ActiveFilterChips from '../search/components/ActiveFilterChips';
import CatalogueFiltersControl from '../search/components/CatalogueFiltersControl';
import SearchDisplayOptionsControl from '../search/components/SearchDisplayOptionsControl';
import SearchExportControl from '../search/components/SearchExportControl';
import SearchFilterControl from '../search/components/SearchFilterControl';
import { useSearchDisplayEffects } from '../search/hooks/useSearchDisplayEffects';
import SearchActions from './SearchActions';

export default function SearchHeader() {
  const searchType = useSearchType();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isCatalogueTab = searchType === SEARCH_TYPE.SALE_CATALOGUES;

  usePublicSearchUrlSync();
  useSearchDisplayEffects();
  useSyncQuickSearchDefaultOperator();

  return (
    <>
      {isMobile ? (
        <Box
          sx={{
            mb: 1.5,
            backgroundColor: 'background.paper',
            borderRadius: '12px',
            boxShadow: `0 2px 8px ${alpha(black[900], 0.08)}`,
            overflow: 'hidden',
          }}
        >
          {isCatalogueTab && (
            <Stack direction="row" spacing={1} sx={{ px: 1.5, py: 1.25 }}>
              <CatalogueFiltersControl isMobile />
            </Stack>
          )}
          <Box sx={{ px: 1.5, py: 1.25 }}>
            <PublicSearchInput variant="mobile" />
          </Box>
          <ActiveFilterChips variant={LAYOUT_VARIANT.MOBILE} />
          <Stack
            direction="row"
            spacing={1}
            sx={{
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: 1.5,
              py: 0.5,
              minHeight: 40,
            }}
          >
            <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
              <SearchDisplayTypeSelection />
              <SearchFilterControl />
              <SearchExportControl />
            </Stack>
          </Stack>
        </Box>
      ) : (
        <Box sx={{ mb: 1.5 }}>
          <Stack
            sx={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: '10px',
              py: '8px',
              px: '10px',
              minWidth: 0,
              backgroundColor: 'background.paper',
              borderRadius: '8px',
              boxShadow: `0 2px 8px ${alpha(black[900], 0.08)}`,
            }}
          >
            <SearchDisplayTypeSelection />
            {isCatalogueTab && <CatalogueFiltersControl isMobile={false} />}
            <PublicSearchInput />
            <SearchFilterControl />
            <SearchDisplayOptionsControl />
            <SearchExportControl />
          </Stack>
          <ActiveFilterChips variant={LAYOUT_VARIANT.DESKTOP} />
        </Box>
      )}
      <SearchActions />
    </>
  );
}
